import React, { createElement, useCallback } from 'react';
import { useFormat } from '@/frontastic/hooks/useFormat';
import { TypographyProps } from './types';
import Skeleton from '../skeleton';

const Typography: React.FC<TypographyProps> = ({
  children,
  className = '',
  translation,
  as = 'p',
  asSkeleton = false,
  ...props
}) => {
  const locale = 'en';

  const { formatMessage } = useFormat({ name: translation?.file });

  const getContent = useCallback(() => {
    // Check if the children has different locales
    if (typeof children !== 'string') {
      // Update text based on locale
      return children?.[locale as string];
    }

    // Check if there is translation
    if (translation) {
      const content = formatMessage({ id: translation.id, defaultMessage: children });
      return content;
    }

    return children;
  }, [formatMessage, locale, translation, children]);

  // Constructing default props of the element
  const elementProps: React.HTMLAttributes<HTMLElement> = {
    className: `${className} relative`,
    ...props,
  };

  const content = (
    <>
      {asSkeleton && <Skeleton />}
      {getContent()}
    </>
  );

  if (as === 'fragment') {
    return content;
  }

  const TypographyElement = createElement(as, elementProps, content);

  return TypographyElement;
};

export default Typography;
